// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"d6329840","130":"0ffdfb59","358":"0aa9534b","721":"01e7e95b"}[chunkId] + ".chunk.css";
};